import { render, staticRenderFns } from "./Defensive.vue?vue&type=template&id=53fefa0c&scoped=true&"
import script from "./Defensive.vue?vue&type=script&lang=js&"
export * from "./Defensive.vue?vue&type=script&lang=js&"
import style0 from "./Defensive.vue?vue&type=style&index=0&id=53fefa0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fefa0c",
  null
  
)

export default component.exports